import React from 'react';

import BasicInfoEdit from './BasicInfoEdit';
import EditModalControl from '../../common/edit/EditModalControl';

interface Props {
  type: 'button' | 'link';
  show?: boolean;
  buttonDataTestId?: string;
  linkDataTestId?: string;
  onSuccess: () => void;
}

const BasicInfoEditModal = ({ type, show, buttonDataTestId, linkDataTestId, onSuccess }: Props) => (
  <EditModalControl
    type={type}
    title={'Edit Basic Info'}
    show={show}
    buttonDataTestId={buttonDataTestId}
    linkDataTestId={linkDataTestId}
    onSuccess={onSuccess}
  >
    <BasicInfoEdit />
  </EditModalControl>
);

export default BasicInfoEditModal;
